import type {
  DetailedUserExternalLoyaltySerializer,
  IApiResponse,
  IResponse,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const externalLoyaltyApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getActiveExternalLoyalty: build.query<
      IApiResponse<DetailedUserExternalLoyaltySerializer>["payload"]["data"],
      { loyalty_token: string }
    >({
      query({ loyalty_token: loyaltyToken }) {
        return {
          url: `/foundation/api/users/me/loyalty/external/${loyaltyToken}`,
          method: "GET",
        };
      },
      transformResponse: (
        response: IApiResponse<DetailedUserExternalLoyaltySerializer>
      ) => {
        return response.payload.data;
      },
    }),
    addMnogoruCard: build.mutation<
      IApiResponse<DetailedUserExternalLoyaltySerializer>,
      { card: string }
    >({
      query({ card }) {
        return {
          url: "/foundation/api/users/me/loyalty/external/mnogoru",
          method: "POST",
          body: {
            card,
          },
        };
      },
    }),
    setMnogoruCardActive: build.mutation<IApiResponse<IResponse>, void>({
      query() {
        return {
          url: "/foundation/api/users/me/loyalty/external/mnogoru/set-active",
          method: "PUT",
        };
      },
    }),
  }),
});
